export const personaHeaderViewProfilebutton = "t_a";
export const personaHeaderViewChatButtonLabel = "u_a";
export default {personaHeaderViewProfilebutton,personaHeaderViewChatButtonLabel};